import { useEffect, useRef, type ReactNode } from "react";
import { createPortal } from "react-dom";
export function BottomSheet({
	title,
	onClose,
	children,
}: {
	title: string;
	onClose: () => void;
	children: ReactNode;
}) {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const previous = document.activeElement as HTMLElement | null;
		const overflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		ref.current?.focus();
		history.pushState({ sheet: true }, "");
		const close = () => onClose();
		window.addEventListener("popstate", close);
		return () => {
			window.removeEventListener("popstate", close);
			document.body.style.overflow = overflow;
			previous?.focus();
		};
	}, []);
	const dismiss = () => {
		if (history.state?.sheet) history.back();
		else onClose();
	};
	return createPortal(
		<div className="bottom-sheet-backdrop">
			<button
				type="button"
				tabIndex={-1}
				className="sheet-backdrop-dismiss"
				aria-label="시트 바깥 눌러 닫기"
				onClick={dismiss}
			/>

			<div
				ref={ref}
				className="bottom-sheet"
				role="dialog"
				aria-modal="true"
				aria-label={title}
				tabIndex={-1}
				onKeyDown={(e) => {
					if (e.key === "Escape") dismiss();
					if (e.key === "Tab") {
						const all = ref.current?.querySelectorAll<HTMLElement>(
							'button:not([disabled]),a[href],input,select,textarea,[tabindex="0"]',
						);
						if (!all?.length) return;
						const first = all[0],
							last = all[all.length - 1];
						if (
							e.shiftKey &&
							(document.activeElement === first ||
								document.activeElement === ref.current)
						) {
							e.preventDefault();
							last?.focus();
						} else if (!e.shiftKey && document.activeElement === last) {
							e.preventDefault();
							first?.focus();
						}
					}
				}}
			>
				<header>
					<h2>{title}</h2>
					<button type="button" onClick={dismiss} aria-label="닫기">
						×
					</button>
				</header>
				{children}
			</div>
		</div>,
		document.body,
	);
}
